module.exports = __webpack_public_path__ + "static/img/attack_arrow.3cdbef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attack_arrow.png
// module id = Oi1Q
// module chunks = 94